
<script lang="ts" setup>
import AUApi from "@/api";
import { ref, onMounted, reactive } from "vue";
import { mountedBase, onSave, BaseSetup, reloadData } from "@/DataLoaderStatic";
import { getSiteData } from "@/NavigationHelper";
import baseList from "@/components/baseList.vue";

const emit = defineEmits<{
  back: [];
}>();
const pageParams: DataPageParameter = {
  zeitbereich: AUApi.Current.zeitbereich,
  insertMode: false,
  emitBack: () => emit("back"),
};
declare interface BaseDialogUIData extends DataPageUIData {
  showDialog: boolean;
}
let initalized = ref<boolean>(false);
const uiData = reactive<BaseDialogUIData>(BaseSetup(pageParams));
let pers = ref<boolean>(false);
onMounted(async () => {
  const siteData = getSiteData();
  if (siteData?.aic) {
    pageParams.aic = siteData.aic;
  }
  if (siteData?.pers) {
    pers = siteData.pers;
  }
  await mountedBase(uiData, pageParams);

  uiData.showLoading = false;
  initalized.value = true;
  uiData.showDialog = true;
});
</script>
<template id="BaseDialog">
  <div min-height="450px" v-if="!uiData.showLoading">
    <baseList
      v-if="initalized"
      :dialog="true"
      @back="uiData.showDialog = false"
      :showHeader="false"
      :queryAic="pageParams.queryAIC"
      :query="pageParams.query"
      :aic="pageParams.aic"
      :zeitbereich="pageParams.zeitbereich"
      :pers="pers"
    />
  </div>
</template>